import { AppSettings } from './../app.settings';
import moment from 'moment/src/moment'

export function formatDateCell(timestamp) {
  return moment(timestamp).format('MMM DD, YYYY hh:mm A');
}

export function formatDateCellInDateOnly(timestamp) {
  return moment(timestamp).format('MMM DD, YYYY');
}

export function toLocalDateAndtime(timeStamp) {
  const now = new Date(timeStamp);
  const localTime = new Date(timeStamp + now.getTimezoneOffset() * 60000);
  return moment(localTime).format('MMM DD, YYYY hh:mm A');
}

export function formatDateTimeAMPMCell(timestamp) {
  if (timestamp && timestamp > 0) {
    return moment(timestamp).format(AppSettings.DATE_TIME_AM_PM_FORMAT_MOMENT);
  } else {
    return 'NA';
  }
}

export function formatTimeCell(timestamp) {
  return moment(timestamp).format(AppSettings.DEFAULT_TIME_FORMATE);
}

export function getDate(timestamp) {
  return moment(timestamp).format(AppSettings.DATE_ONLY_FORMATE);
}

export function getUTCDate(timestamp) {
  const duration = moment.duration(timestamp, 'milliseconds');
  // Get hours, minutes, and seconds from the duration
  const hours = ('00' + Math.floor(duration.asHours()).toString()).slice(-2);
  const minutes = ('00' + duration.minutes().toString()).slice(-2);
  const seconds = ('00' + duration.seconds().toString()).slice(-2);
  return `${hours}:${minutes}:${seconds}`;
}


export function getDateAsPerTenant(timestamp) {
  const dateFormat = this.commonBindingDataService.getDateFormatFromTenant();
  return moment(timestamp).format(dateFormat);
}

export function getDateFromMeta(timestamp) {
  return moment(timestamp).format(AppSettings.DATE_FORMAT);
}

export function getDateMMDDYY(timestamp) {
  return moment(timestamp).format(AppSettings.DATE_MMDDYYYY_FORMATE);
}


export function getDateByMMDDYYYY(timestamp) {
  return moment(timestamp).format(AppSettings.DATE_MMDDYYYY_FORMATE);
}

export function getDateOnly(timestamp) {
  return moment(timestamp).format('DD MMM');
}

export function formatTimeCellToMin(timestamp) {
  return moment(timestamp).format(AppSettings.DEFAULT_TIME_FORMATE);
}

export function formatTimeCellToMin1(timestamp) {
  return moment(timestamp).format(AppSettings.DEFAULT_MIN_TIME_FORMATE);
}

export function getTimeInAMPM(timestamp) {
  return moment(timestamp).format(AppSettings.TIME_FORMATE_AMPM);
}
